import ContentCard from './content_card';

export default ContentCard;
